// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MLZ6","colBig":"styles_colBig__26_x-","colSmall":"styles_colSmall__13ukh"};